module.exports = __webpack_public_path__ + "Flag-626.e043577cf678cf19212daee0ee411f6e.svg";